import { useState, useEffect } from 'react';
import './Blog.scss';
import cn from 'classnames';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Form from '../../components/Form';
import Image1 from './image1.jpg';
import Image2 from './image2.jpg';

const BlogList = () => {
  const navigate = useNavigate();
  const [isFormOpen, setFormOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  return (
    <div className='page'>
      <Header onFormClick={() => setFormOpen(true)} />
      <div className='blogListHeader'>
        <span className='blogListTitle'>NextDeavor Insights</span>
        <span className='blogListText'>
          Discover expert insights on hiring, recruitment strategies, and career development to help you navigate today's
          competitive job market.
        </span>
      </div>
      <div className='blogList'>
        <div className='blogCard' onClick={() => navigate('/blog/10-ways-humans-are-better-than-an-ai-interviewer/')}>
          <div className='blogCardImage'>
            <img src={Image1} />
          </div>
          <span className='blogCardTitle'>10 ways humans are better than an AI Interviewer.</span>
          <span className='blogCardText'>
            The ethical concerns of AI in recruitment are real, especially in interviews where understanding people requires a
            uniquely human touch.
          </span>
          <span className='blogCardDetails'>
            Richard Nguyen • October 13, 2025 <span className='blogCardDetails'>10 min</span>
          </span>
        </div>
        <div className='blogCard' onClick={() => navigate('/blog/AI-can-find-matches/')}>
          <div className='blogCardImage'>
            <img src={Image2} />
          </div>
          <span className='blogCardTitle'>AI Can Find Matches. Humans Create Meaning.</span>
          <span className='blogCardText'>
            As OpenAI steps into recruiting, one truth remains: technology can streamline the process, but only people can truly
            connect talent and purpose.
          </span>
          <span className='blogCardDetails'>
            Richard Nguyen • October 5, 2025 <span className='blogCardDetails'>3 min</span>
          </span>
        </div>
      </div>
      <Footer />
      {isFormOpen && <Form onClose={() => setFormOpen(false)} />}
    </div>
  );
};

export default BlogList;
